export default "__VITE_ASSET__BBKgKTEf__"